export const panToBoundCircle = (
  circle: {center: naver.maps.Coord; radius: number},
  map: naver.maps.Map,
  options?: naver.maps.Margin
) => {
  if (!circle || !map) {
    return;
  }

  const instance = new naver.maps.Circle({
    center: circle.center,
    radius: circle.radius,
    map,
    strokeOpacity: 0,
    fillOpacity: 0,
  });

  map.panToBounds(instance.getBounds(), undefined, options);

  instance.setMap(null);
};

export const panToBoundsPolygon = (
  paths: naver.maps.ArrayOfCoords[],
  map: naver.maps.Map,
  options?: naver.maps.Margin
) => {
  if (!paths || !map) {
    return;
  }

  const instance = new naver.maps.Polygon({
    paths,
    strokeOpacity: 0,
    fillOpacity: 0,
  });

  map.panToBounds(instance.getBounds(), undefined, options);
  instance.setMap(null);
};
